<template>
  <v-row class="pt-5" v-if="items && items.length">
    <v-col cols="10" offset="1">
      <v-switch v-model="showSentence" label="Show statement"></v-switch>
    </v-col>
    <v-col cols="10" offset="1">
      <div v-for="item in items" :key="item.id" class="mb-10">
        <div class="mb-3">
          <h2 class="ma-0">{{ displayName(item.uid) || "Unnamed user" }}</h2>
          <p v-if="emailFor(item.uid) && displayName(item.uid)" class="caption ma-0 grey--text text--darken-1">
            {{ emailFor(item.uid) }}
          </p>
        </div>

        <v-card light class="mb-5" v-if="showSentence">
          <v-card-text>
            <p class="subtitle-1 ma-0">For</p>
            <p class="heading 1a-0 black--text" v-html="item.doc.textAudience"></p>
            <p class="heading ma-0 black--text" v-html="item.doc.textCompany"></p>
            <p class="subtitle-1 ma-0">Is</p>
            <p class="heading ma-0 black--text" v-html="item.doc.textFeatures"></p>
            <p class="subtitle-1 ma-0">That</p>
            <p class="heading ma-0 black--text" v-html="item.doc.textBenefits"></p>
            <p class="subtitle-1 ma-0">Because</p>
            <p class="heading ma-0 black--text" v-html="item.doc.textEvidence"></p>
          </v-card-text>
        </v-card>

        <v-row>
          <v-col cols="3">
            <p class="blue--text headline">Audience</p>
            <ul class="list--none">
              <li class="ma-1" v-for="(tag, index) in (item.doc && item.doc.audience) || []"
                :key="`a-${item.id}-${index}`">
                <span class="pr-2">{{ tag.title }}</span>
              </li>
            </ul>
          </v-col>
          <v-col cols="3">
            <p class="green--text headline">Features</p>
            <ul class="list--none">
              <li class="ma-1" v-for="(tag, index) in (item.doc && item.doc.features) || []"
                :key="`f-${item.id}-${index}`">
                <span class="pr-2">{{ tag.title }}</span>
              </li>
            </ul>
          </v-col>
          <v-col cols="3">
            <p class="deep-orange--text headline">Benefits</p>
            <ul class="list--none">
              <li class="ma-1" v-for="(tag, index) in (item.doc && item.doc.benefits) || []"
                :key="`b-${item.id}-${index}`">
                <span class="pr-2">{{ tag.title }}</span>
              </li>
            </ul>
          </v-col>
          <v-col cols="3">
            <p class="pink--text headline">Evidence</p>
            <ul class="list--none">
              <li class="ma-1" v-for="(tag, index) in (item.doc && item.doc.reasons) || []"
                :key="`e-${item.id}-${index}`">
                <span class="pr-2">{{ tag.title }}</span>
              </li>
            </ul>
          </v-col>
        </v-row>

        <v-divider class="mt-8"></v-divider>
      </div>
    </v-col>
  </v-row>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsPropositionUser",
  data() {
    return {
      items: null,
      admins: null,
      profileCache: {},
      showSentence: false
    };
  },
  props: {
    uid: String,
    id: String,
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  mounted() {
    this.getAdmins();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getAdmins() {
      let ref = fb.profilesCollection.where("webrole", "==", "admin");
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post.uid);
          });
          if (items) {
            this.admins = items;
          }
          this.getExercise();
        })
        .catch(function () { });
    },
    getExercise() {
      let ref = fb.propositionExCollection.where("pid", "==", this.id);
      ref
        .get()
        .then((result) => {
          let items = [];
          result.forEach((doc) => {
            const post = doc.data();
            items.push(post);
            this.fetchProfile(post.uid);
          });
          this.items = items;
        })
        .catch(function () { });
    },
    fetchProfile(uid) {
      if (!uid) return;
      if (uid in this.profileCache) return;
      this.$set(this.profileCache, uid, null);
      fb.profilesCollection
        .where("uid", "==", uid)
        .get()
        .then((snap) => {
          const doc = snap.docs[0] && snap.docs[0].data();
          this.$set(this.profileCache, uid, doc || null);
        })
        .catch(() => {
          this.$set(this.profileCache, uid, null);
        });
    },
    displayName(uid) {
      const p = uid && this.profileCache[uid];
      if (!p) return "";
      const full = [p.first, p.last].filter(Boolean).join(" ").trim();
      return full || p.email || "";
    },
    emailFor(uid) {
      const p = uid && this.profileCache[uid];
      return (p && p.email) || "";
    },
  },
};
</script>
